import {deps, inject, observer, StatefulComponent} from '../../lib/component';
import {px, rem} from 'csx';
import {style} from 'typestyle';
import * as React from 'react';
import imgNormal from '../../theme/icon/google_signin_buttons/web/2x/btn_google_signin_dark_normal_web@2x.png';
import imgFocus from '../../theme/icon/google_signin_buttons/web/2x/btn_google_signin_dark_focus_web@2x.png';
import imgPressed from '../../theme/icon/google_signin_buttons/web/2x/btn_google_signin_dark_pressed_web@2x.png';
import {colorSignInInfo} from '../../theme/color';
import infoIcon from '../../static/ico-tip.svg';

type Props = {
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): any
};

type State = {
  imgSrc: string;
  showInfo: boolean;
}

@inject(deps) @observer
export default class GoogleSignIn extends StatefulComponent<Props, State> {
  state = {
    imgSrc: imgNormal,
    showInfo: false,
  };

  render() {
    const {youtubeLoginURL, user} = this.props.model.auth;

    if (user)
      return null;

    const {imgSrc, showInfo} = this.state;
    const focusImg = this.setImage.bind(this, imgFocus);
    const normalImg = this.setImage.bind(this, imgNormal);
    const pressImg = this.setImage.bind(this, imgPressed);

    return (
      <div className={GoogleSignIn.styles.container}>
        <a
          className={GoogleSignIn.styles.link}
          href={youtubeLoginURL}
          rel="nofollow"
          onClick={this.handleClick}
          onFocus={focusImg}
          onBlur={normalImg}
          onMouseDown={pressImg}
          onMouseUp={normalImg}
          onKeyDown={pressImg}
          onKeyUp={normalImg}
        >
          <img src={imgSrc} alt="Sign in with Google" />
        </a>
        {showInfo && (
          <div className={GoogleSignIn.styles.info}>
            <img className={GoogleSignIn.styles.infoIcon} src={infoIcon} />
            If you’ve already signed up, please sign in using the account you initially registered with on the next page
          </div>
        )}
      </div>
    )
  }

  handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!this.state.showInfo) {
      event.preventDefault();
      return this.setState({showInfo: true});
    }

    if (this.props.onClick) {
      event.preventDefault();
      this.props.onClick(event);
    }
  };

  setImage = (imgSrc: string) => this.setState({imgSrc});

  static styles = {
    container: style({
      zIndex: 42,
      width: px(296),
      $nest: {
        '& a': {
          width: px(296),
          display: 'block',
          $nest: {
            '& img' : {
              width: px(196),
              margin: '0 auto'
            }
          }
        }
      }
    }),
    link: style({
      textAlign: 'center',
    }),
    info: style({
      margin: '10px 0 0 0',
      textAlign: 'left',
      fontSize: rem(0.818),
      fontWeight: 500,
      color: colorSignInInfo.toString(),
      position: 'relative'
    }),
    infoIcon: style({
      width: '13px',
      height: '13px',
      position: 'absolute',
      left: px(-25),
      top: px(5),
    })
  }
}